import React from 'react'
import { Div, Button } from '@driftt/tide-core'

import './style.css'

const OnboardingFooter = ({ nextFunction, isLoading = false, isDisabled = false}) => (
  <Div className="onboarding-footer">
    <Div className="onboarding-footer-continue-button-container">
        <Button className="onboarding-footer-continue-button" loading={isLoading} disabled={isDisabled} onClick={nextFunction}>Continue</Button>
    </Div>
  </Div>
)

export default OnboardingFooter
